import IconWrapper from "@components/svg_icon_wrapper"

export default function ConversationCardLiveChatIcon() {
  return (
    <IconWrapper sx={{ width: 14, height: 14 }}>
      <svg
        id="wa-whatsapp-icon"
        xmlns="http://www.w3.org/2000/svg"
        width="512"
        height="512"
        viewBox="0 0 512 512"
      >
        <path
          id="Path_4965"
          data-name="Path 4965"
          d="M512,382.07c0,2.8-.09,8.88-.26,13.58-.41,11.49-1.32,26.32-2.7,33.07a109.76,109.76,0,0,1-9.27,27.71,98.45,98.45,0,0,1-43.43,43.39,110.209,110.209,0,0,1-27.87,9.28c-6.69,1.35-21.41,2.24-32.82,2.65-4.71.17-10.79.25-13.58.25H129.97c-2.8,0-8.88-.09-13.58-.26-11.49-.41-26.32-1.32-33.07-2.69a110.367,110.367,0,0,1-27.72-9.28A98.5,98.5,0,0,1,12.18,456.3,110.209,110.209,0,0,1,2.9,428.43C1.55,421.74.66,407,.25,395.61.08,390.91,0,384.82,0,382V129.9c0-2.8.09-8.88.25-13.58C.71,104.86,1.62,90,3,83.28a110.371,110.371,0,0,1,9.27-27.72A98.59,98.59,0,0,1,55.7,12.18,110.21,110.21,0,0,1,83.57,2.9C90.26,1.55,105,.66,116.39.25,121.09.08,127.18,0,130,0H382.1c2.8,0,8.88.09,13.58.25C407.14.71,422,1.62,428.72,3a110.37,110.37,0,0,1,27.72,9.27A98.59,98.59,0,0,1,499.82,55.7a110.207,110.207,0,0,1,9.28,27.87c1.35,6.69,2.24,21.41,2.65,32.82.17,4.7.25,10.79.25,13.58Z"
          fill="#167cfc"
          fillRule="evenodd"
        />
        <g
          id="Group_10141"
          data-name="Group 10141"
          transform="translate(77.605 77.393)"
        >
          <g id="Group_136" data-name="Group 136" transform="translate(0 0)">
            <path
              id="Path_85"
              data-name="Path 85"
              d="M409.4,522.761c-21.847-5.357-44.966-7.9-65.176-16.873-19.716-8.756-37.857-9.407-57.9-5.42-29.053,5.776-39.745-4.806-33.554-33.821,4.276-20.036,1.87-37.6-5.944-57.2-26.99-67.732-16.715-131.639,33.24-185.336,50.2-53.956,113.7-71.461,184.772-48.949,70.123,22.214,111.967,71.477,122.412,143.874C602.776,426.618,519.119,520.376,409.4,522.761ZM305.047,448.546c15.713,4.828,33.282,8.932,49.8,15.6,27.77,11.195,55.934,15.267,85.266,9C516.2,456.89,561.9,378.658,539.238,303.813c-22.2-73.3-103.941-112.4-176.746-84.542-72.335,27.678-105.347,111.04-72.671,181C297.084,415.829,300.329,433.224,305.047,448.546Z"
              transform="translate(-232.276 -165.578)"
              fill="#fff"
              stroke="#177bfb"
              strokeWidth="12"
            />
            <path
              id="Path_87"
              data-name="Path 87"
              d="M286.207,216.62a21.917,21.917,0,0,1,21.5,24.224c-1.163,13.672-9.143,20.841-22.838,20.583-14.03-.262-20.976-8.81-21.858-21.973C262.171,226.8,273.435,216.277,286.207,216.62Z"
              transform="translate(-177.22 -60.431)"
              fill="#fff"
            />
            <path
              id="Path_4967"
              data-name="Path 4967"
              d="M286.207,216.62a21.917,21.917,0,0,1,21.5,24.224c-1.163,13.672-9.143,20.841-22.838,20.583-14.03-.262-20.976-8.81-21.858-21.973C262.171,226.8,273.435,216.277,286.207,216.62Z"
              transform="translate(-106.969 -60.431)"
              fill="#fff"
            />
            <path
              id="Path_4968"
              data-name="Path 4968"
              d="M286.207,216.62a21.917,21.917,0,0,1,21.5,24.224c-1.163,13.672-9.143,20.841-22.838,20.583-14.03-.262-20.976-8.81-21.858-21.973C262.171,226.8,273.435,216.277,286.207,216.62Z"
              transform="translate(-36.72 -60.431)"
              fill="#fff"
            />
          </g>
        </g>
      </svg>
    </IconWrapper>
  )
}
